
import { Component, Vue, Emit, Prop } from "vue-property-decorator";
import GenericTable, { TableHeader } from "./table/generic-table.vue";
import { ServerTableDetails } from "@/store/devices/types";
import { PaginatedSearchQueryParams } from "@/store/types";

@Component({
  components: {
    "generic-table": GenericTable
  }
})

export default class OnTestTable extends Vue {
  @Prop({ type: Array }) public serverList: ServerTableDetails[];
  @Prop({ type: Number }) public totalServerCount: number;
  @Prop({ type: Boolean, default: true, required: false }) showTableSearch: boolean;
  @Prop({ type: String, default: null, required: false }) private searchQuery: string;

  private columns: TableHeader[] = [
		{
			title: "Title",
			key: "title",
			order: 1,
			sortOrder: 0,
			sortOrderReversed: false,
			description: "Device Name",
			searchable: true,
			visible: true,
			dataType: "string",
			isTermLabel: true,
			sortable: true,
			isSortedByDefault: true,
		},
		{
			title: "Type",
			key: "deviceTypeTitle",
			sortKey: "type",
			order: 2,
			sortOrder: 0,
			sortOrderReversed: false,
			description: "Device Type",
			searchable: true,
			visible: true,
			dataType: "string",
			isTermLabel: true,
			sortable: true,
			isSortedByDefault: true,
		},
		{
			title: "Area",
			key: "groupName",
			sortKey: "Area",
			order: 3,
			sortOrder: 0,
			sortOrderReversed: false,
			description: "Device Area",
			searchable: true,
			visible: true,
			dataType: "string",
			isTermLabel: true,
			sortable: true,
			isSortedByDefault: true,
		},
		{
			title: "Host",
			key: "host",
			order: 4,
			sortOrder: 0,
			sortOrderReversed: false,
			description: "Device Host",
			searchable: true,
			visible: true,
			dataType: "string",
			isTermLabel: true,
			sortable: true,
			isSortedByDefault: true,
		},
		{
			title: "Port",
			key: "port",
			order: 5,
			sortOrder: 0,
			sortOrderReversed: false,
			description: "Device Port",
			searchable: true,
			visible: true,
			dataType: "string",
			isTermLabel: true,
			sortable: true,
			isSortedByDefault: true,
		},
    	{
			title: "On Test",
			key: "onTestColumnText",
			order: 5,
			sortOrder: 0,
			sortOrderReversed: false,
			description: "Device On Test",
			searchable: true,
			visible: true,
			dataType: "string",
			isTermLabel: true,
			sortable: false,
			isSortedByDefault: true,
			width: "15rem"
		},
  ]

  @Emit("openOnTest")
  private openOnTest(selectedRow: ServerTableDetails): ServerTableDetails {
    return selectedRow;
  }

  @Emit("fetchServers")
  public async updateData(paginatedSearchQueryParams?: PaginatedSearchQueryParams): Promise<PaginatedSearchQueryParams> {
    return paginatedSearchQueryParams;
  }
}
